import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type DragMatchingImageStylesType = {
  outerDiv: CSSProperties;
  imageChoicesContainer: CSSProperties;
  imageContainer: CSSProperties;
  textContainer: CSSProperties;
};

export const DragMatchingImageStyles: DragMatchingImageStylesType = {
  outerDiv: {
    ...cssClass.outerDiv,
    gap: "5%",
  },

  imageChoicesContainer: {
    display: "grid",
    // gridTemplateColumns: "repeat(2, 1fr)",
    // gap: "0.75rem", // react native cannot read this 2 line => moved to web and mobile renderer component override
  },

  imageContainer: {
    position: "relative",
    overflow: "hidden",
    aspectRatio: "1/1",
    backgroundColor: backgroundColors.white,
    ...cssClass.bigRadius,
    ...cssClass.centerFlex,
    ...cssClass.boxShadow,
  },

  textContainer: {
    ...cssClass.textContainerBase,
    ...cssClass.bigFont,
  },
};
